import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

interface LanguageTag {
  code: string;
  label: string;
}

interface LanguageTagsDisplayProps {
  languages: LanguageTag[];
  maxDisplay?: number;
}

export const LanguageTagsDisplay: React.FC<LanguageTagsDisplayProps> = ({
  languages,
  maxDisplay = 2,
}) => {
  const { t: _t } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(false);

  if (languages.length === 0) {
    return (
      <span className="no-languages">
        {_t("reviewRequestPrintsPage.no_languages_selected")}
      </span>
    );
  }

  const displayedLanguages = languages.slice(0, maxDisplay);
  const remainingLanguages = languages.slice(maxDisplay);
  const remainingCount = languages.length - maxDisplay;

  return (
    <div className="language-tags-display">
      {displayedLanguages.map((lang) => (
        <span key={lang.code} className="language-tag">
          {lang.label}
        </span>
      ))}
      {remainingCount > 0 && (
        <span
          className="language-tag more-tag"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {_t("hookForm.languageSelect.customLanguagesSelect.show_more", {
            count: remainingCount,
          })}
          {showTooltip && (
            <div className="language-tooltip">
              {remainingLanguages.map((lang) => (
                <div key={lang.code} className="tooltip-item">
                  {lang.label}
                </div>
              ))}
            </div>
          )}
        </span>
      )}
    </div>
  );
};
